import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import './PuzzleCard.css';

function PuzzleCard({ puzzle }) {
  const { slug, title, is_meta, solved } = puzzle;
  const thumbnailUrl = `/images/puzzles/${slug}.png`;

  return (
    <Link to={`/puzzles/${slug}`} className="puzzle-card">
      {solved && (
        <div className="puzzle-card-solved">
          <CheckCircle size={24} />
        </div>
      )}
      
      {is_meta && <span className="puzzle-card-badge meta">Meta</span>}
      
      <div className="puzzle-card-image">
        <img 
          src={thumbnailUrl} 
          alt={title}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      
      <h3 className="puzzle-card-title">{title}</h3>
    </Link>
  );
}

export default PuzzleCard;
